import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import {
  Facebook,
  Instagram,
  Linkedin,
  Twitter,
  Youtube,
} from "../../../app-constants";

function Footer({ phone }) {
  return (
    <div className="tekrevol_footer">
      <Container>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="footer_title"
          >
            <p>Have a Project To Discuss?</p>
            <h2>We’re ready!</h2>
            <div className="footer_btn">
              <Link to="/contact" className="btn_primary">
                Let’s Connect!
              </Link>
            </div>
          </Col>
          <Col xs={12} md={12} lg={6} xl={5} xxl={5} className="footer_links">
            <h4>Services</h4>
            <ul>
              <li>
                <Link to="https://www.tekrevol.com/custom-software-development">
                  Custom Software Development
                </Link>
              </li>
              <li>
                <Link to="/android-app-development">
                  Android App Development
                </Link>
              </li>
              <li>
                <Link to="https://www.tekrevol.com/iphone-app-development">
                  IPhone App Development
                </Link>
              </li>
              <li>
                <Link to="https://www.tekrevol.com/web-development">
                  Web Development
                </Link>
              </li>
              <li>
                <Link to="https://www.tekrevol.com/game-development">
                  Game Development
                </Link>
              </li>
              <li>
                <Link to="https://www.tekrevol.com/mobile-app-support">
                  Mobile App Support
                </Link>
              </li>
              <li>
                <Link to="/startup-app-development">
                  Startup App Development
                </Link>
              </li>
              <li>
                <Link to="https://www.tekrevol.com/flutter-app-development">
                  Flutter App Development
                </Link>
              </li>
              <li>
                <Link to="/cross-platform-app-development">
                  Cross Platform App Development
                </Link>
              </li>
              <li>
                <Link to="https://www.tekrevol.com/react-native-app-development">
                  React Native App Development
                </Link>
              </li>
            </ul>
          </Col>
          <Col xs={12} md={12} lg={6} xl={5} xxl={5} className="footer_links">
            <h4>Solutions</h4>
            <ul>
              <li>
                <Link to="/solution/automotive-app-development">
                  Automotive App Development
                </Link>
              </li>
              <li>
                <Link to="https://www.tekrevol.com/healthcare-app-development">
                  Healthcare App Development
                </Link>
              </li>
              <li>
                <Link to="https://www.tekrevol.com/on-demand-app-development">
                  On-Demand App Development
                </Link>
              </li>
              <li>
                <Link to="https://www.tekrevol.com/solution/ecommerce-app-development">
                  Ecommerce App Development
                </Link>
              </li>
              <li>
                <Link to="/solution/real-estate-app-development">
                  Real Estate App Development
                </Link>
              </li>
              <li>
                <Link to="https://www.tekrevol.com/solution/music-app-developers">
                  Music App Development
                </Link>
              </li>
              <li>
                <Link to="https://www.tekrevol.com/solution/it-staff-augmentation">
                  IT Staff Augmentation
                </Link>
              </li>
            </ul>
          </Col>
          <Col
            xs={12}
            md={12}
            lg={4}
            xl={2}
            xxl={2}
            className="footer_links last_links"
          >
            <h4>About Us</h4>
            <ul>
              <li>
                <Link to="/about">About TekRevol</Link>
              </li>
              <li>
                <a href="https://www.tekrevol.com/blogs/partnership-program/">
                  Referral Program
                </a>
              </li>
              <li>
                <Link href="/blogs/">Blogs</Link>
              </li>
              <li>
                <Link to="/press-release">Press</Link>
              </li>

              <li>
                <Link to="/location">Location</Link>
              </li>
            </ul>
          </Col>
          <Col xs={12} md={6} lg={4} xl={8} xxl={8} className="footer_loaction">
            <h4>Locations</h4>
            <ul>
              <li>
                <Link
                  to="https://goo.gl/maps/b3UJcKpXPfk8Djy97"
                  target="_blank"
                  rel="nofollow"
                >
                  HOU
                </Link>
              </li>
              <li>
                <Link
                  to="https://goo.gl/maps/G8CcLSTNpsVpc6Fa9"
                  target="_blank"
                  rel="nofollow"
                >
                  ATX
                </Link>
              </li>
              <li>
                <Link
                  to="https://goo.gl/maps/tES1CukeViAzbrH96"
                  target="_blank"
                  rel="nofollow"
                >
                  DTX
                </Link>
              </li>
              <li>
                <Link
                  to="https://goo.gl/maps/aW2tprA4dn8H6uhX9"
                  target="_blank"
                  rel="nofollow"
                >
                  SF
                </Link>
              </li>
              <li>
                <Link
                  to="https://goo.gl/maps/BdvwoKwfu3RiqmKRA"
                  target="_blank"
                  rel="nofollow"
                >
                  MIA
                </Link>
              </li>
              <li>
                <Link
                  to="https://goo.gl/maps/duxvF5z7sTB1Nx8y9"
                  target="_blank"
                  rel="nofollow"
                >
                  CHI
                </Link>
              </li>
              <li>
                <Link
                  to="https://goo.gl/maps/YpXXqekezaXqBgad6"
                  target="_blank"
                  rel="nofollow"
                >
                  NYC
                </Link>
              </li>
              <li>
                <Link
                  to="https://goo.gl/maps/Kz4DY2zH13YFHgeb7"
                  target="_blank"
                  rel="nofollow"
                >
                  DC
                </Link>
              </li>
              <li>
                <Link
                  to="https://goo.gl/maps/oensJKsmfBoXkof69"
                  target="_blank"
                  rel="nofollow"
                >
                  LA
                </Link>
              </li>
              <li>
                <Link
                  to="https://goo.gl/maps/wDiGPbbTyqVw4BqF9"
                  target="_blank"
                  rel="nofollow"
                >
                  DXB
                </Link>
              </li>
              <li>
                <Link
                  to="https://goo.gl/maps/7bLnXYi1scnskq2x5"
                  target="_blank"
                  rel="nofollow"
                >
                  QA
                </Link>
              </li>
              <li>
                <Link
                  to="https://goo.gl/maps/1QuUt2L4yYRThWiVA"
                  target="_blank"
                  rel="nofollow"
                >
                  BH
                </Link>
              </li>
              <li>
                <Link
                  to="https://maps.app.goo.gl/in4GxFfWWtB1D1bR7"
                  target="_blank"
                  rel="nofollow"
                >
                  KSA
                </Link>
              </li>
              <li>
                <Link
                  to="https://maps.app.goo.gl/JcMRT4it6o7ETwoN6"
                  target="_blank"
                  rel="nofollow"
                >
                  LDN
                </Link>
              </li>
            </ul>
            <ul className="contact_information">
              {phone !== undefined && phone !== "" ? (
                <li>
                  <Link to={`tel:${phone.replace(/\D/g, "")}`}>
                    {phone.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3")}
                  </Link>
                </li>
              ) : (
                <li>
                  <Link to="tel:+18003629239" rel="noopener">
                    +1 800-362-9239
                  </Link>
                </li>
              )}
              <li>
                <Link to="mailto:info@tekrevol.com" rel="noopener">
                  info@tekrevol.com
                </Link>
              </li>
            </ul>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={4}
            xl={4}
            xxl={4}
            className="mt-xl-auto footer_social"
          >
            <ul>
              <li>
                <Link
                  to="https://www.facebook.com/TekRevolOfficial/"
                  target="_blank"
                  aria-label="TekRevol Facebook"
                  rel="nofollow"
                >
                  {Facebook}
                </Link>
              </li>
              <li>
                <Link
                  to="https://twitter.com/tekrevol"
                  target="_blank"
                  rel="nofollow"
                  aria-label="TekRevol Twitter"
                >
                  {Twitter}
                </Link>
              </li>
              <li>
                <Link
                  to="https://www.youtube.com/channel/UCuweDx9zWc2ket4n4QLUbNQ"
                  target="_blank"
                  rel="nofollow"
                  aria-label="TekRevol Youtube"
                >
                  {Youtube}
                </Link>
              </li>
              <li>
                <Link
                  to="https://www.instagram.com/tekrevol/"
                  target="_blank"
                  rel="nofollow"
                  aria-label="TekRevol Instagram"
                >
                  {Instagram}
                </Link>
              </li>
              <li>
                <Link
                  to="https://www.linkedin.com/company/tekrevol/"
                  target="_blank"
                  rel="nofollow"
                  aria-label="TekRevol Linkedin"
                >
                  {Linkedin}
                </Link>
              </li>
            </ul>
          </Col>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="mt-4">
            <div className="dmca_logo_img">
              <a
                href="//www.dmca.com/Protection/Status.aspx?ID=ccdd7c5b-8b55-46c8-ae17-509a8d0cc782"
                title="DMCA.com Protection Status"
                class="dmca-badge"
                rel="nofollow"
              >
                <img
                  src="https://images.dmca.com/Badges/_dmca_premi_badge_4.png?ID=ccdd7c5b-8b55-46c8-ae17-509a8d0cc782"
                  alt="DMCA.com Protection Status"
                />
              </a>
            </div>
          </Col>
        </Row>
        <Row>
          <Col
            xs={12}
            md={5}
            lg={6}
            xl={6}
            xxl={6}
            className="footer_copyright"
          >
            <div className="copyright_txt">
              © Tekrevol 2025. All rights reserved
            </div>
          </Col>
          <Col
            xs={12}
            md={7}
            lg={6}
            xl={6}
            xxl={6}
            className="footer_copyright_links"
          >
            <ul>
              <li>
                <Link to="/terms-conditions">Terms and Conditions</Link>
              </li>
              <li>
                <Link to="/privacy-policy">Privacy Policy</Link>
              </li>
              <li>
                <Link to="/contact">Contact Us</Link>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Footer;
